import React from "react";
import styled from "styled-components";
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { BREAK_POINTS } from '../../constants';

const Wrapper = styled.section`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
`;

const ProfileGridSection = styled(motion.section)`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ProfileGridItemWrapper = styled(motion.div)`
  position: relative;
  width: 100%;
  cursor: pointer;
  
  &::before {
    content: '';
    display: block;
    padding-bottom: 135.5%;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, transparent, transparent);
    transition: background-image 1s ease;
    pointer-events: none;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: grayscale(100%);
    transition: filter 1s ease, opacity 0.3s ease;
    will-change: transform;
    transform: translateZ(0);
  }

  /* hover 효과 */
  &:hover {
    /* img {
      filter: grayscale(0%);
      transition: filter 0.5s ease;
    } */
    
    &::after {
      background-image: linear-gradient(to bottom, #949cca, #949cca);
      opacity: 0.3; // 그라데이션 투명도 조절
    }
    
    .name-overlay {
      opacity: 1;
      transition: opacity 1s ease;
    }
  }
`;

const NameOverlay = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: white;
  font-size: 24px;
  opacity: 0;
  transition: opacity 0.3s ease;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 가독성을 위한 그림자 효과
`;

function MainPresenter({ main, navigateToProfile }) {
  return (
    <Wrapper>
      <ProfileGrid main={main} navigateToProfile={navigateToProfile} />
    </Wrapper>
  );
};

const ProfileGrid = ({ main, navigateToProfile }) => {
  return (
    <ProfileGridSection
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {main.map((item, index) => (
        <ProfileGridItem 
          key={index} 
          item={item} 
          navigateToProfile={navigateToProfile} 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.1 }}
        />
      ))}
    </ProfileGridSection>
  );
}

const ProfileGridItem = ({ item, navigateToProfile }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1, // 0.5
    rootMargin: '50px',
  });

  React.useEffect(() => {
    const img = new Image();
    img.src = item.img;
  }, [item.img]);

  return (
    <ProfileGridItemWrapper 
      ref={ref} 
      onClick={() => navigateToProfile(item.id)}
      initial={{ opacity: 0 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={{ duration: 0.3 }}
    >
      {inView ? (
        <>
          <img 
            src={item.img} 
            alt={item.name} 
            loading="lazy" 

            decoding="async"
            style={{ opacity: 0 }}
            onLoad={(e) => {
              e.target.style.opacity = 1;
              e.target.style.transition = 'opacity 0.3s';
            }}
          />
          <NameOverlay className="name-overlay">{item.name}</NameOverlay>
        </>
      ): (
        <div 
          style={{ 
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: '#f5f5f5'
          }} 
        />
      )}
    </ProfileGridItemWrapper>
  );
}

export default MainPresenter;
